import { useCreateFieldGetter } from '@/common/customisation/composables';
import { PUI } from '@pleased-npm/fe-customisation';

/**
 * Composable for ConversationsPagination component customisation
 * Returns styling for pagination text and icons
 */
export const usePaginationCustomisation = () => {
  const { getField } = useCreateFieldGetter({
    registryId: PUI.REGISTRY_IDS.CONVERSATIONS_PAGE,
    sectionKey: PUI.CONVERSATIONS_SECTION_KEYS.CARD_PAGINATION,
    blockKey: PUI.CONVERSATIONS_BLOCK_KEYS.BODY_SECTION,
  });

  return {
    textColor: getField(PUI.COMMON_FIELD_KEYS.TEXT_COLOR),
    activeIconColor: getField(PUI.COMMON_FIELD_KEYS.ACTION_COLOR),
    disabledIconColor: getField(PUI.COMMON_FIELD_KEYS.DISABLED_ICON_COLOR),
  };
};
